import { FieldTypeId } from '@/enums/fieldType'
import { formatDateToISO } from '@/scripts/formatDate'

export const getCurrentValueForDisplay = (value) => {
  switch (value) {
    case 'true':
    case true:
      return 'Да'
    case 'false':
    case false:
      return 'Нет'
    case 'null':
    case null:
    case undefined:
      return '-'
    default:
      return value
  }
}

export const getCurrentValueForFilter = (filter) => {
  switch (filter.fieldTypeId) {
    case FieldTypeId.Date:
      return formatDateToISO(filter.value)
    case FieldTypeId.RadioButton:
    case FieldTypeId.Checkbox:
      return JSON.parse(filter.value)
    default:
      return String(filter.value)
  }
}
